// extracted by mini-css-extract-plugin
export default {"wrapper":"Sidebar_wrapper__ym8Pk","item":"Sidebar_item__FxZLP","icon":"Sidebar_icon__NZeN6","label":"Sidebar_label__cogb6","active":"Sidebar_active__9A-Rt"};